export default {
  title: '分类浏览',
  breadcrumb: '分类',
  articlesCount: '篇文章',
  noArticles: '该分类暂无文章',
  sortBy: '排序方式',
  sortLatest: '最新发布',
  sortHot: '最热阅读',
  allCategories: '全部分类',
}